import '../../sass/pages/_homeQatar.scss'

// IMPORT HELPERS
import { pageLoaded } from "../utils/helpers";

// IMPORT COMPONENTS
import "../components/awardSwiper";
import "../components/curiositySwiper";
import SplitText from "../components/splitText";

declare var gsap: any;
declare var ScrollTrigger: any;
gsap.registerPlugin(ScrollTrigger);

const startTrigger = { start: 'top bottom-=50px' }
const defaultTransition = (translate: { [t: string]: number }) => {
    return { opacity: 0, ...translate }
}
declare global {
    interface Window {
      drupalSettings: any,
      dataLayer: any;
    }
  }

// Initialize
init()

function init() {
    let sections = setInitialState()
    new SplitText('.mxbudqtr-awards__title, .mxbudqtr-tada__title')

    pageLoaded(() => animate(sections))
}

function setInitialState(): any {
    // Banner Section
    let bTitle = gsap.set('.mxbudqtr-banner__title', { ...defaultTransition({ translateY: 30 }) })
    let bSubtitle = gsap.set('.mxbudqtr-banner__subtitle', { ...defaultTransition({ translateX: -30 }) })
    let bDesc = gsap.set('.mxbudqtr-banner__desc', { ...defaultTransition({ translateX: -30 }) })
    let bBtn = gsap.set('.mxbudqtr-banner__btn', { ...defaultTransition({ translateX: -30 }) })
    let bImage = gsap.set('.mxbudqtr-banner__image', { opacity: 0 })
    let allSwiper = gsap.set('.swiper-pagination', { opacity: 0 })

    // Participate Section
    let pMessage = gsap.set('.mxbudqtr-participate__message', { ...defaultTransition({ translateY: 30 }) })
    let pTitle = gsap.set('.mxbudqtr-participate__title', { ...defaultTransition({ translateX: 30 }) })
    let pDesc = gsap.set('.mxbudqtr-participate__desc', { ...defaultTransition({ translateX: 30 }) })
    let pImage = gsap.set('.mxbudqtr-participate__bottle', { opacity: 0 })

    // Awards Section
    let aCards = gsap.set('.mxbudqtr-award-card', { ...defaultTransition({ translateX: 30 }) })
    let aBtn = gsap.set('.mxbudqtr-awards__btn', { opacity: 0 })

    // Tada Section

    return {
        firstSection: { bTitle, bSubtitle, bDesc, bBtn, bImage, allSwiper },
        secondSection: { pMessage, pTitle, pDesc, pImage },
        thirdSection: { aCards, aBtn }
    }
}

function animate(sections: any) {
    animateBannerSection(sections.firstSection)
    animateParticipateSection(sections.secondSection)
    animateAwardsSection(sections.thirdSection)
    animateTadaSection()
    animateCuriositiesSection()
}

// Animate Banner Section
function animateBannerSection({ bTitle, bSubtitle, bDesc, bBtn, bImage, allSwiper }: any) {
    const tl = gsap.timeline({ ease: 'power1.in' });

    tl.to(bTitle.targets(), { duration: 0.8, opacity: 1, translateX: 0, translateY: 0 }, 'mainTitle')
    tl.to(bSubtitle.targets(), { duration: 0.8, opacity: 1, translateX: 0, translateY: 0 }, 'mainTitle+=0.5')
    tl.to(bDesc.targets(), { duration: 0.8, opacity: 1, translateX: 0, translateY: 0 }, 'mainTitle+=0.8')
    tl.to(bBtn.targets(), { duration: 0.8, opacity: 1, translateX: 0, translateY: 0 }, 'mainTitle+=1.1')
    tl.to(bImage.targets(), { duration: 0.8, opacity: 1, ease: 'power1.in' }, 'mainTitle+=1.2')

    allSwiper.targets().forEach((item: any) => {
        gsap.to(item, {
            duration: .8, opacity: 1,
            scrollTrigger: { trigger: item, ...startTrigger }
        })
    })
}

// Animate Participate Section
function animateParticipateSection({ pMessage, pTitle, pDesc, pImage }: any) {
    gsap.to(pMessage.targets()[0], {
        duration: .8, opacity: 1, translateX: 0, translateY: 0,
        scrollTrigger: { trigger: pMessage.targets()[0], ...startTrigger }
    })

    pTitle.targets().forEach((item: any) => {
        gsap.to(item, {
            duration: .8, opacity: 1, translateX: 0, translateY: 0,
            scrollTrigger: { trigger: item, ...startTrigger }
        })
    })

    pDesc.targets().forEach((item: any) => {
        gsap.to(item, {
            duration: .8, opacity: 1, translateX: 0, translateY: 0,
            scrollTrigger: { trigger: item, ...startTrigger }
        })
    })

    gsap.to(pImage.targets(), {
        duration: .8, opacity: 1,
        ease: 'power1.in',
        scrollTrigger: { trigger: pImage.targets(), ...startTrigger }
    })
}

// Animate Awards Section
function animateAwardsSection({ aCards, aBtn }: any) {
    gsap.to(aCards.targets(), {
        duration: .8, opacity: 1, translateX: 0, stagger: 0.2,
        scrollTrigger: { trigger: '#AwardsSwiper', ...startTrigger }
    })

    gsap.to(aBtn.targets(), {
        duration: .8, opacity: 1,
        scrollTrigger: { trigger: aBtn.targets(), ...startTrigger }
    })
}

// Animate Tada Section
function animateTadaSection() {
    let tadaElms = gsap.utils.toArray('.mxbudqtr-tada__desc, .mxbudqtr-tada__body .mxbudqtr-btn, .mxbudqtr-tada__image-source')
    tadaElms.forEach((elm: any) => {
        gsap.from(elm, {
            duration: .8, opacity: 0, translateY: 30, stagger: .2,
            scrollTrigger: { trigger: elm, ...startTrigger }
        })
    })
}

// Animate Curiosities Section
function animateCuriositiesSection() {
    gsap.from('.mxbudqtr-curiosity-card__image', {
        duration: .8, opacity: 0,
        scrollTrigger: { trigger: '.mxbudqtr-curiosity-card__image', ...startTrigger }
    })

    gsap.from('.mxbudqtr-curiosity-card__message, .mxbudqtr-curiosity-card__desc, .mxbudqtr-curiosity-card__btn', {
        duration: .8, opacity: 0, translateX: -30, stagger: .2,
        scrollTrigger: { trigger: '.mxbudqtr-curiosity-card__article', start: 'top bottom-=100px' }
    })
}

window.addEventListener("load", () => {
    setTimeout(() => {
        const itemBtnBanner = document.querySelector(
            ".mxbudqtr-banner__btn"
          ) as HTMLElement;
          if (itemBtnBanner) {
            itemBtnBanner.addEventListener("click", (e: any) => {
              window.dataLayer.push({
                'event': 'GAEvent',​
                'event_category': 'Content',​
                'event_action': 'Content', ​
                'event_label':  'Participa',
                'interaction':'true',​
                'component_name': 'Participa',
                'element_text':  'Copa-Mundial-de-la-FIFA-Catar-2022'
              });
            });
          }
          const itemBtnPremios = document.querySelector(
            ".mxbudqtr-awards__btn"
          ) as HTMLElement;
          if (itemBtnPremios) {
            itemBtnPremios.addEventListener("click", (e: any) => {
              window.dataLayer.push({
                'event': 'GAEvent',​
                'event_category': 'Content',​
                'event_action': 'Content', ​
                'event_label':  'Catar 2022', // Dinámico:  *Nombre de la campaña
                'interaction':'true',​
                'component_name': 'Participar',
                'element_text': 'Catar 2022' // Dinámico: *Nombre de la campaña
              });
            });
          }
          const itemBtnPartic= document.querySelector(
            ".mxbudqtr-tada__article a"
          ) as HTMLElement;
          if (itemBtnPartic) {
            itemBtnPartic.addEventListener("click", () => {
                window.dataLayer.push({
                    'event': 'GAEvent',
                    'event_category': 'Content',
                    'event_action': 'Content',
                    'event_label':  'Ingresar-a-Ta-Da',
                    'interaction':'true',
                    'component_name': 'Ingresar-a-Ta-Da',
                    'element_text':  'Ta-Da-Copa-Mundial-de-la-FIFA-Catar-2022'
                });
            });
          }
    }, 500);    
})